// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yKmGi","colBig":"styles_colBig__jwUIp","colSmall":"styles_colSmall__1JQQV","shopifyNameWrapper":"styles_shopifyNameWrapper__1iWN9"};